import React, {FC, useEffect, useState} from 'react'
import {useSalesInvoicesusequerypayment } from '../contextProviders/Atomqueryprovider'
import {useAuth} from '../../app/modules/auth'
import io from 'socket.io-client'
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone'
import relativeTime from 'dayjs/plugin/relativeTime'
import calendar from 'dayjs/plugin/calendar'
import localizedFormat from 'dayjs/plugin/localizedFormat'

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(relativeTime)
dayjs.extend(calendar)
dayjs.extend(localizedFormat)


const CURRENCY_APP = process.env.REACT_APP_CURRENCY
const OPENING_TIME = process.env.REACT_APP_OPENING_TIME
const socket = io('possocket.27mirrors.com')

const UnpaidbillsToggleDrawer: FC = () => {
  
    const {currentUser, logout} = useAuth()
    const [startlimit, setStartlimit] = useState<number>(0)
    const [paginationsize, setPaginationsize] = useState<number>(10)
    const [itemto_order, setItemto_order] = useState<string>('date_recorded')
    const [desorasc, setDesorasc] = useState<string>('DESC')
    const [serversort, setServersort] = useState<any>([])
    const [search_item, setSearch_item] = useState<string>('%')
    
    const {
        isLoading: salesinvoiceisloading,
        isSuccess: salesinvoicedsuccess,
        data: salesinvoicedata,
        isPreviousData: salesinvoiceispreviousdata,
        status: salesinvoicestatus,
        refetch: salesinvoicerefetch
      } = useSalesInvoicesusequerypayment(
        Number(currentUser?.user_id),
        startlimit,
        paginationsize,
        new Date(dayjs.unix(dayjs(dayjs().startOf('month').subtract(7, 'days').format('YYYY-MM-DD') + OPENING_TIME).unix()).format('YYYY-MM-DD hh:mm')),
        new Date(dayjs.unix(dayjs(dayjs().add(1, 'M').startOf('month').format('YYYY-MM-DD') + OPENING_TIME).unix()).format('YYYY-MM-DD hh:mm')),
        itemto_order,
        desorasc,
        search_item,
        ["CREDIT", "NOT PAID"]
      )
    
   
      socket.on('update', async (arg) => {
        try {
          await salesinvoicerefetch()
        } catch (error) {
          console.log(error)
        } finally {
          console.log("refetch success")
        }
      })

    

   return (
    <>
   {salesinvoicedsuccess ? salesinvoicedata?.data.datalength > 0 ?
    <button
        id="kt_engage_demos_toggle"
        className="engage-demos-toggle btn btn-flex h-35px bg-body btn-color-gray-700 btn-active-color-gray-900 shadow-sm fs-6 px-4 rounded-top-0"
        title={`Check out unpaid bills`}
        data-bs-toggle="tooltip"
        data-bs-placement="left"
        data-bs-dismiss="click"
        data-bs-trigger="hover">

    <span id="kt_engage_demos_label">
  <span className="bullet bullet-dot bg-danger h-8px w-8px animation-blink opacity-50 me-2"></span>
		Unpaid Bills
	</span>
    </button>
    :
    <></>
    :
    <></>}
   </>
   )
}


export {UnpaidbillsToggleDrawer}